import GameItem from './GameItem';

export default GameItem;
